import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { APP_ROUTES } from '@/api/constants/app.url';

export function NotFoundPage() {
    return (
        <div className="flex min-h-screen items-center justify-center bg-neutral-50 p-6">
            <div className="text-center">
                <p className="text-[11px] font-semibold uppercase tracking-wider text-neutral-400">404</p>
                <h1 className="mt-2 font-display text-2xl font-bold text-navy">Page not found</h1>
                <p className="mt-1 text-sm text-neutral-500">That route doesn’t exist (yet).</p>
                <Link
                    to={APP_ROUTES.HOME}
                    className="focus-ring mt-4 inline-flex items-center gap-1 text-sm text-sky hover:underline"
                >
                    <ArrowLeft className="h-3.5 w-3.5" /> Back to home
                </Link>
            </div>
        </div>
    );
}
